export default {
  cashBook: []
}
